export default {
  cashBook: []
}
